/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {Module} from "@intuitionrobotics/ts-common";
import {ThunderDispatcher} from "@intuitionrobotics/thunderstorm/frontend";


export interface OnMediaPlayed {
	__onMediaPlayed: (playerId: string) => void;
}

export interface OnStopAllPlayers {
	__onStopAllPlayers: () => void;
}

export const dispatch_onMediaPlayed = new ThunderDispatcher<OnMediaPlayed, "__onMediaPlayed">("__onMediaPlayed");
export const dispatch_onStopAllPlayers = new ThunderDispatcher<OnStopAllPlayers, "__onStopAllPlayers">("__onStopAllPlayers");

export class PlayerModule_Class
	extends Module {

	notifyPlayers(playingPlayerId: string) {
		dispatch_onMediaPlayed.dispatchUI(playingPlayerId)
	}

	stopAllPlayers() {
		dispatch_onStopAllPlayers.dispatchUI()
	}
}

export const PlayerModule = new PlayerModule_Class("PlayerModule");
